import { render, staticRenderFns } from "./addPageReturn.vue?vue&type=template&id=7f62bde2&scoped=true&"
import script from "./addPageReturn.vue?vue&type=script&lang=js&"
export * from "./addPageReturn.vue?vue&type=script&lang=js&"
import style0 from "./addPageReturn.vue?vue&type=style&index=0&id=7f62bde2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f62bde2",
  null
  
)

export default component.exports